import { Bound } from "lib/@components/binding/Bound"
import { Table, TableBody, TableContainer, useTheme } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { PreviewRow } from "routes/asset-register/plugins/excel-import/preview-row"
import { NoResults } from "lib/@components/no-results/no-results"

export function SheetViewer({ sheet, firstColumn, sx, lastColumn, minRowCount = 50 }) {
    const columns = Math.min(sheet.columnCount, 100)
    const rows = Math.min(sheet.rowCount, minRowCount)
    const list = sheet.getRows(1, rows)
    const theme = useTheme()

    return (
        <Bound firstColumn={firstColumn} lastColumn={lastColumn} worksheet={sheet} columns={columns} rows={rows}>
            {list?.length > 0 ? (
                <TableContainer sx={{ ...sx, "& tr": { whiteSpace: "nowrap" }, width: 1, overflow: "auto" }}>
                    <Table
                        size="small"
                        sx={{
                            "& .MuiTableCell-root": {
                                borderBottom: "1px solid" + theme.palette.grey[500_24],
                                height: "53px",
                            },
                        }}
                    >
                        <TableBody>
                            <Repeat list={list} item={<PreviewRow columns={columns} sheet={sheet} />} />
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <NoResults>No data in selected tab</NoResults>
            )}
        </Bound>
    )
}
